import React, { FC, useEffect, useState } from 'react';
import { PositionBookmarkListItemVO } from '@domain/vo/common/PositionBookmarkListItemVO';
import PositionList from '@components/phs/test/positionList';
import classnames from 'classnames/bind';
import styles from './jobPositionList.module.scss';
import ArrayUtil from '@utils/array/util';

const cx = classnames.bind(styles);

// [D] 포지션이 없는 경우
const EmptyArea = () => {
  return (
    <div className={cx('emptyArea')}>
      <em className={cx('emptyTitle')}>포지션을 기다리고 있어요.</em>
      <p className={cx('emptyDesc')}>기업에서 채용을 시작하면 포지션을 확인할 수 있어요.</p>
    </div>
  );
};

interface PositionProps {
  positions?: PositionBookmarkListItemVO[];
}

const Position: FC<PositionProps> = ({ positions }) => {
  const [positionList, setPositionList] = useState<PositionBookmarkListItemVO[]>([]);

  useEffect(() => {
    setPositionList(ArrayUtil.shuffleArray(positions || []));
  }, [positions]);

  const getPositionList = () => {
    if (!positionList.length) return <EmptyArea />;
    return <PositionList positionList={positionList} />;
  };

  return <>{getPositionList()}</>;
};

export default Position;
